module.exports = __webpack_public_path__ + "img/questions_icon_on.6f7803be.svg";